var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.303,
    height: 53.303,
    viewBox: "0 0 53.303 53.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(1231.5 3827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1231.5 -3827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M57.24,8.418a2.227,2.227,0,0,0-2.851-1.324L47.3,9.694a26.651,26.651,0,1,0,5.233,23.225A2.232,2.232,0,0,0,48.2,31.851a22.2,22.2,0,0,1-37.7,9.913L49.134,27.576A2.227,2.227,0,0,0,47.6,23.394L8.121,37.89a2.2,2.2,0,0,0-.412.2c-.362-.6-.7-1.209-1-1.842L51.975,19.635a2.227,2.227,0,1,0-1.534-4.182L5.172,32.07q-.26-1-.42-2l42.6-15.646,8.561-3.144A2.225,2.225,0,0,0,57.24,8.418ZM4.494,25.412A22.2,22.2,0,0,1,42.816,11.341Z",
    transform: "translate(-0.005 0.105)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopima);
export default __webpack_public_path__ + "static/media/copima.36fedc5ddc4786b75401c913dfddbf13.svg";
export { ForwardRef as ReactComponent };